import SalifyCollectionSection from "./default";
export default SalifyCollectionSection;
